import { render, staticRenderFns } from "./PrefixList.vue?vue&type=template&id=10b3c9bc&"
import script from "./PrefixList.vue?vue&type=script&lang=js&"
export * from "./PrefixList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports